import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import type { RootState } from '../../../store';
import generateNavItems from '../UtilAppContent';
import type { MenuItem, MenuItemsConfig } from '@/AppUtils';
import { createMenuItems } from '@/AppUtils';

interface UseMenuItemsProps {
  presentComponents: string[];
  chargerMenuItems: MenuItem[];
  onMenuItemClick: (item: string) => void;
  onChargerMenuItemClick: (e: any) => void;
  dispatch: any;
  isNewIndustry: boolean;
}

export const useMenuItems = ({
  presentComponents,
  chargerMenuItems,
  onMenuItemClick,
  onChargerMenuItemClick,
  dispatch,
  isNewIndustry,
}: UseMenuItemsProps) => {
  const navigate = useNavigate();

  const {
    userInfo,
    permittedCustomers,
    customerSites,
    FactoryPath,
    ExecutivePath,
    selectedCustomerName,
    selectedSite,
    selectedKey,
  } = useSelector((state: RootState) => state.userInfo);

  const { loading: loadingPower } = useSelector((state: RootState) => state.power);

  // Memoize the navigation items generation
  const navItems = useMemo(() =>
    generateNavItems(
      selectedCustomerName,
      selectedSite,
      selectedKey,
      permittedCustomers,
      dispatch,
      navigate,
      userInfo
    ),
    [selectedCustomerName, selectedSite, selectedKey, permittedCustomers, dispatch, navigate, userInfo]
  );

  const menuItems = useMemo(() => {
    const config: MenuItemsConfig = {
      presentComponents,
      chargerMenuItems,
      selectedCustomerName,
      selectedSite,
      selectedKey,
      permittedCustomers,
      customerSites,
      userInfo,
      FactoryPath,
      ExecutivePath,
      loadingPower,
      onMenuItemClick,
      onChargerMenuItemClick,
      navigate,
      navItems,
      isNewIndustry,
    };

    return createMenuItems(config);
  }, [
    navItems,
    userInfo,
    customerSites,
    selectedCustomerName,
    selectedSite,
    permittedCustomers,
    FactoryPath,
    ExecutivePath,
    selectedKey,
    presentComponents,
    chargerMenuItems,
    loadingPower,
    navigate,
    onMenuItemClick,
    onChargerMenuItemClick
  ]);
  return menuItems;
};